module.exports = "<app-navigation-menu></app-navigation-menu>\n<router-outlet></router-outlet>"